import React, { useState } from "react";
import { TabContent, TabPane } from "reactstrap";
import classnames from "classnames";
import FeatureRequestList from "./FeatureRequestList";
import "./feature-requests.scss";

const FeatureRequests = () => {
  const [activeTab, setActiveTab] = useState("inbox");

  return (
    <div className="eventdetailsaddbox rd_noshadow feature-requests-page">
      <div className="boxheader rd_floatingheaderthig">
        <div className="rd_inputselectheader">
          <div className="rd_selectheaderrdt2 rd_selectheaderrdt2profile">
            <button
              className={classnames({ active: activeTab === "inbox" })}
              onClick={() => setActiveTab("inbox")}
            >
              Inbox
            </button>
            <button
              className={classnames({ active: activeTab === "library" })}
              onClick={() => setActiveTab("library")}
            >
              Ideas Library
            </button>
          </div>
        </div>
      </div>

      <TabContent activeTab={activeTab}>
        <TabPane tabId="inbox">
          {activeTab === "inbox" && (
            <FeatureRequestList
              status="open"
              filterTitle="Open Ideas"
              emptyTitle="No open feature requests"
              emptyMessage="New ideas from the admin navbar appear here until you mark them as done."
            />
          )}
        </TabPane>
        <TabPane tabId="library">
          {activeTab === "library" && (
            <FeatureRequestList
              status="done"
              filterTitle="Ideas Library"
              emptyTitle="No completed ideas yet"
              emptyMessage="Ideas you mark as done are archived here for future reference."
            />
          )}
        </TabPane>
      </TabContent>
    </div>
  );
};

export default FeatureRequests;
